function ChangeVariantTitleMobile(variantPickerArg){
  if(window.innerWidth < 767){
    var productTitleDiv = document.getElementById('product-title-div');
    var h1Element = document.querySelector('.product-detail__title.small-title');
    let variant_title = variantPickerArg.value;
    var secondChild = productTitleDiv.children[1];
 
    if (secondChild && secondChild.tagName.toLowerCase() === 'h2') {
      secondChild.textContent = variant_title;
    } 
    else {
      var h2Element = document.createElement('h2');
      h2Element.textContent = variant_title;
      productTitleDiv.insertBefore(h2Element, h1Element.nextSibling);
    }
  }
}

function DisplayDescriptions(number){
  for(i=0; i<8; i++){
    let shortVariantDescription = document.getElementById('variant_short_description-' + i)
    if(shortVariantDescription){
      if(i+1 == number){
          shortVariantDescription.style.display = "block";
      }
      else{
          shortVariantDescription.style.display = "none";
      }
    }
    let longVariantDescription = document.getElementById('variant_long_description-' + i )
    if(longVariantDescription){
      if(i+1 == number){
          longVariantDescription.style.display = "block";
      }
      else{
          longVariantDescription.style.display = "none";
      }
    }
  }
}

function VariantImagesCarouselRender(number){
 for(i=0; i<8; i++){
  if(i==0)
  {
   let carousel = document.getElementById("carousel-container")
   if(carousel){
    if(i+1 == number){
     carousel.style.display = "block";
    }
    else{
     carousel.style.display = "none";
    }
   }
   let arrows = document.getElementById("arrows_dots")
   if(arrows){
    if(i+1 == number){
     arrows.style.display = "flex";
    }
    else{
     arrows.style.display = "none";
    }
   }
  }
  else
  {
   {
   let carousel = document.getElementById("carousel-container" + (i+1))
   if(carousel){
    if(i+1 == number){
     carousel.style.display = "block";
    }
    else{
     carousel.style.display = "none";
    }
   }
   let arrows = document.getElementById("arrows_dots" + (i+1));  
   if(arrows){
    if(i+1 == number){
     arrows.style.display = "flex";
    }
    else{
     arrows.style.display = "none";
    }
   }
  }
 }
 }
}

function RenderPreorderMessage(variantPicker){
  var elementPREORDER = document.querySelector('.preorder_Metafield');
  let preorderVariant = variantPicker.getAttribute('data-preorder-variant')
  if(preorderVariant == "true"){
    if (elementPREORDER) {
       var myInput = document.getElementById('preorder_box');
       myInput.disabled = false;
       elementPREORDER.style.display = "flex"
    }
  }
  else if(preorderVariant == "false"){
    if (elementPREORDER) {
        var myInput = document.getElementById('preorder_box');
        myInput.disabled = true;
        elementPREORDER.style.display = "none"
    }
  }
}

function CloudboxCheck(variantPicker,variant_label){
  let cloudbox = variantPicker.getAttribute('data-cloudbox')
  if(cloudbox=="true"){
    let cloudbox_option_name = variantPicker.getAttribute('data-cloudbox-option-name')
    let cloudbox_option_selected = variantPicker.value;
    variant_label.textContent = cloudbox_option_name;
    var spanElement = document.createElement('span');
    spanElement.className = 'js-option-title';
    spanElement.textContent = cloudbox_option_selected;
    variant_label.appendChild(spanElement);
   }
}

let variantPickers = document.getElementsByClassName('productVariantPicker');
let ar = Array.from(variantPickers);

ar.forEach(function(variantPicker, variantPickers) {
  
variantPicker.addEventListener('click', ()=>{
  let variant_label = document.getElementById('variant_label')
  let number = variantPicker.getAttribute('data-variant');
  DisplayDescriptions(number)
  ChangeVariantTitleMobile(variantPicker)
  VariantImagesCarouselRender(number)
  RenderPreorderMessage(variantPicker)
  CloudboxCheck(variantPicker,variant_label)
})
})

























                                 